import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const VehicleGroup = ({ roles }) => {

    return (
        <M_Table entityName={'VehicleGroup'} filtersOnTable rolePermissions={roles} />
    )
}